import React from 'react';
import { Image as ImageIcon } from 'lucide-react';

export const UploadField = ({
  title,
  subTitle,
  x,
  y,
  onChange,
  size,
  preview = '',
  registration,
  button,
}) => {
  return (
    <div>
      {title && <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-200">{title}</h4>}
      {subTitle && <p className="text-xs text-gray-500 mb-2">{subTitle}</p>}

      {preview ? (
        <div className="rounded-md border border-dashed border-gray-200 dark:border-gray-700 p-3 bg-white dark:bg-gray-800">
          <div className="flex justify-end">{button}</div>
          <img
            src={preview}
            alt="preview"
            className="w-full rounded-md cursor-pointer"
            onClick={() => window.open(preview, '_blank')}
          />
        </div>
      ) : (
        <label className="block rounded-md border border-dashed border-gray-200 dark:border-gray-700 p-6 text-center bg-white dark:bg-gray-800 cursor-pointer">
          <div className="mx-auto inline-flex items-center gap-3">
            <ImageIcon className="h-8 w-8 text-gray-300" />
            <div className="text-sm text-gray-600 dark:text-gray-300">
              Click to upload or drag and drop
              <div className="text-xs text-gray-400 mt-1">
                Recommended: {x}×{y}px — Max size: {size}
              </div>
            </div>
          </div>
          <input
            type="file"
            accept="image/*"
            className="sr-only"
            onChange={onChange}
            {...registration}
          />
        </label>
      )}
    </div>
  );
};
